// submit.js

import { useStore } from './store';

export const SubmitButton = () => {
  const { nodes, edges } = useStore((state) => ({
    nodes: state.nodes,
    edges: state.edges,
  }));

  const handleSubmit = async () => {
    // Prepare the pipeline data
    const pipelineData = {
      nodes: nodes,
      edges: edges,
    };

    try {
      // Send POST request to backend
      const response = await fetch('http://localhost:8000/pipelines/parse', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pipelineData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Show alert with results
      const dagStatus = result.is_dag ? '✓ Valid DAG' : '✗ Contains Cycles';
      const message = `\\n📊 Pipeline Analysis\\n\\nNodes: ${result.num_nodes}\\nEdges: ${result.num_edges}\\nDAG Status: ${dagStatus}`;
      
      alert(message);
    } catch (error) {
      console.error('Error submitting pipeline:', error);
      alert(`Error: ${error.message}\\n\\nMake sure the backend is running at http://localhost:8000`);
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
    }}>
      <button 
        onClick={handleSubmit}
        style={{
          padding: '12px 30px',
          fontSize: '14px',
          fontWeight: '600',
          borderRadius: '6px',
          border: 'none',
          background: '#000',
          color: 'white',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.25)',
          transition: 'all 0.3s ease',
          letterSpacing: '0.5px',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.35)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.25)';
        }}
      >
        Submit Pipeline
      </button>
    </div>
  );
}
